export enum ReceiptEnum{
  NONE ='NONE',
  DEPOSIT ='DEPOSIT',
  WITHDRAW ='WITHDRAW',
  TRANSFER= 'TRANSFER',
  COMMISSION= 'COMMISSION'
}
